import type {
  GridFilters,
  GridFiltersChangeFn,
} from '../../../components/GridFiltersManager/filterDefinitions';
import type { ContentTypeDefinition } from '../../flotiq-client/types/api-response';

import { IFlotiqPluginEvent } from './IFlotiqPluginEvent';

type GridRenderFilterEventInit = {
  /** Full path to the field within the object */
  accessor?: string;
  /** Field input type */
  inputType?: string;
  /** Function to update filters */
  updateFilters: GridFiltersChangeFn;
  /** All current filters */
  allFilters: GridFilters;
  /** Content type that includes the field */
  contentType?: ContentTypeDefinition;
};

/**
 * An event that is fired when a grid filter is being rendered.
 * Returning anything will replace the default filter control for the field.
 *
 * @eventName "flotiq.grid.filter::render"
 * @memberof FlotiqPlugins.Events
 * @returns {null|string|array|number|boolean|HTMLElement|ReactElement}
 *          Null if rendering should be passed to either Flotiq or other plugins.
 *          Renderable result if plugin wants to replace the default renderer.
 */
export class GridRenderFilterEvent extends IFlotiqPluginEvent {
  constructor(initData: GridRenderFilterEventInit) {
    super(initData);
  }
}
